/**
 * <read-more> — clamps text on mobile with a Read more / Read less toggle.
 *
 * Usage:
 *   <read-more>
 *     <div data-read-more-text class="max-md:line-clamp-4">…</div>
 *     <button type="button" data-read-more-toggle class="md:hidden" hidden>Read more</button>
 *   </read-more>
 *
 * The clamp class is removed while expanded. The toggle only shows when the
 * clamped text actually overflows.
 */
if (!customElements.get('read-more')) {
  class ReadMore extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('[data-read-more-text]');
      this.toggle = this.querySelector('[data-read-more-toggle]');
      if (!this.text || !this.toggle) return;

      this.clampClass = this.dataset.clampClass || 'max-md:line-clamp-4';
      this.expanded = false;

      this.onClick = () => this.setExpanded(!this.expanded);
      this.onResize = () => this.updateToggle();
      this.toggle.addEventListener('click', this.onClick);
      window.addEventListener('resize', this.onResize);

      this.updateToggle();
    }

    disconnectedCallback() {
      if (this.toggle) this.toggle.removeEventListener('click', this.onClick);
      window.removeEventListener('resize', this.onResize);
    }

    setExpanded(expanded) {
      this.expanded = expanded;
      this.text.classList.toggle(this.clampClass, !expanded);
      this.toggle.setAttribute('aria-expanded', String(expanded));
      this.toggle.textContent = expanded ? 'Read less' : 'Read more';
      this.updateToggle();
    }

    updateToggle() {
      const overflowing = this.text.scrollHeight > this.text.clientHeight + 1;
      this.toggle.hidden = !(this.expanded || overflowing);
    }
  }

  customElements.define('read-more', ReadMore);
}
